exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bannerMedia-card__type {\n  position: relative;\n  color: #fff;\n  padding: 8px;\n}\n.bannerMedia-card__tag {\n  position: absolute;\n  color: #fff;\n}\n.bannerMedia-card__buffet-type {\n  background: #1890ff;\n  color: #fff;\n}\n.bannerMedia-card__reservation-type {\n  background: #52c41a;\n  color: #fff;\n}\n.bannerMedia-card__full-price {\n  font-size: 12px;\n}\n.bannerMedia-card__price {\n  font-size: 14px;\n  font-weight: 500;\n}\n.bannerMedia-card__type-addional-info {\n  padding: 0 0 0 8px;\n}\n.bannerMedia-card__tag__full {\n  background: #f7931e;\n}\n", ""]);

// exports
